import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditBeforeAfter({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const add = () => set("items", [...(value.items || []), { name: "", before: "", after: "", weeks: "", description: "" }]);
  const remove = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Antes & Depois">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="ba-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="ba-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="ba-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Transformações</span>
            <ListAddBtn onClick={add} label="Adicionar" testId="ba-add" />
          </div>
          <div className="space-y-4">
            {(value.items || []).map((it, i) => (
              <div key={i} data-testid={`ba-row-${i}`} className="border border-border p-4 space-y-3">
                <div className="grid sm:grid-cols-2 gap-3">
                  <Field label="Nome"><TextInput value={it.name} onChange={(v) => setItem(i, "name", v)} testId={`ba-name-${i}`} /></Field>
                  <Field label="Tempo (ex: 12 semanas)"><TextInput value={it.weeks} onChange={(v) => setItem(i, "weeks", v)} testId={`ba-weeks-${i}`} /></Field>
                </div>
                <ImageUploadField label="Foto ANTES" value={it.before} onChange={(v) => setItem(i, "before", v)} testId={`ba-before-${i}`} />
                <ImageUploadField label="Foto DEPOIS" value={it.after} onChange={(v) => setItem(i, "after", v)} testId={`ba-after-${i}`} />
                <Field label="Descrição"><TextArea value={it.description} onChange={(v) => setItem(i, "description", v)} rows={2} testId={`ba-description-${i}`} /></Field>
                <div className="flex justify-end"><ListRemoveBtn onClick={() => remove(i)} testId={`ba-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
